import { useEffect, useState } from 'react';

export const useCooldown = () => {
  const [until, setUntil] = useState<number | null>(null);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!until) {
      return;
    }

    const id = window.setInterval(() => {
      const next = Date.now();
      setNow(next);
      if (next >= until) {
        window.clearInterval(id);
      }
    }, 1000);

    return () => window.clearInterval(id);
  }, [until]);

  const secondsLeft = until ? Math.max(0, Math.ceil((until - now) / 1000)) : 0;

  const start = (seconds: number) => {
    const nextUntil = Date.now() + seconds * 1000;
    setUntil(nextUntil);
    setNow(Date.now());
  };

  return { secondsLeft, start };
};
